// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var InvoiceNinja = require("../../../../shared/src/bindings/InvoiceNinja.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebTypes_View = require("../../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var ReactHotToast = require("react-hot-toast");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var BrowserComponents_HR = require("../../../../shared-browser/src/components/BrowserComponents_HR.bs.js");
var WebComponents_Header = require("../../components/WebComponents_Header.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Icon = require("../../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Modal = require("../../../../shared-browser/src/components/BrowserComponents_Modal.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var WebTypes_MarketingCallout = require("../../types/WebTypes_MarketingCallout.bs.js");
var BrowserComponents_Dropdown = require("../../../../shared-browser/src/components/BrowserComponents_Dropdown.bs.js");
var BrowserComponents_WithModal = require("../../../../shared-browser/src/components/BrowserComponents_WithModal.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserBindings_ReactHotToast = require("../../../../shared-browser/src/bindings/BrowserBindings_ReactHotToast.bs.js");
var BrowserComponents_SpacedElements = require("../../../../shared-browser/src/components/BrowserComponents_SpacedElements.bs.js");
var BrowserComponents_MobilePopoutMenu = require("../../../../shared-browser/src/components/BrowserComponents_MobilePopoutMenu.bs.js");
var WebContainers_BusinessDashboard_ToDo = require("./WebContainers_BusinessDashboard_ToDo.bs.js");
var WebContainers_BusinessDashboard_Shifts = require("./WebContainers_BusinessDashboard_Shifts.bs.js");
var WebContainers_BusinessDashboard_Payments = require("./WebContainers_BusinessDashboard_Payments.bs.js");
var WebContainers_BusinessDashboard_Settings = require("./WebContainers_BusinessDashboard_Settings.bs.js");

var youtubeEmbed = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.border(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
            TAG: /* Grey */2,
            _0: /* Lightest */4
          }),
      tl: {
        hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.rem(26.35)),
          tl: {
            hd: BrowserStyle.mobileMedia({
                  hd: BrowserStyle.height(BrowserStyle.rem(20.0)),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var Styles = {
  youtubeEmbed: youtubeEmbed
};

function WebContainers_BusinessDashboard$Modals$NewToDoTabMarketingCallout(Props) {
  var hideModal = Props.hideModal;
  return React.createElement(BrowserComponents_Modal.Message.make, {
              children: React.createElement(BrowserComponents_FlexColumn.make, {
                    children: null
                  }, React.createElement(BrowserComponents_Text.make, {
                        children: "One place to manage all of your tasks!"
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Medium */4
                      }), React.createElement("iframe", {
                        className: youtubeEmbed,
                        title: "YouTube video player",
                        allowFullScreen: true,
                        src: "https://www.youtube.com/embed/_W7243qxzzo"
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Medium */4
                      }), React.createElement("span", undefined, React.createElement(ReactUtils.S.make, {
                            children: "Ready to pay out tips within the new To-Do tab? Check out this "
                          }), React.createElement("a", {
                            href: "https://bit.ly/38b91D4",
                            target: "_blank"
                          }, React.createElement(ReactUtils.S.make, {
                                children: "Help Center"
                              })), React.createElement(ReactUtils.S.make, {
                            children: " article to learn more."
                          }))),
              primaryButton: {
                disabled: false,
                onClick: hideModal,
                title: "Got It"
              },
              title: "🎊 Introducing the To-Do Tab 🎊",
              widthConstraint: /* FixedWidthCustomRem */{
                _0: 50.0
              }
            });
}

var NewToDoTabMarketingCallout = {
  Styles: Styles,
  make: WebContainers_BusinessDashboard$Modals$NewToDoTabMarketingCallout
};

function getContent(hideModal, param, param$1) {
  return React.createElement(WebContainers_BusinessDashboard$Modals$NewToDoTabMarketingCallout, {
              hideModal: hideModal
            });
}

var Modals = {
  NewToDoTabMarketingCallout: NewToDoTabMarketingCallout,
  getContent: getContent
};

var getBusinessReferralLink = "https://qwick.typeform.com/to/ZKyHpz8w";

function getInvoiceUrlForKey(param) {
  return Relude_Globals.$great$great(InvoiceNinja.ContactKey.toString, (function (param) {
                return "https://app.invoiceninja.com/client/dashboard/" + param;
              }), param);
}

function postAShift(resetPostAShift, setView) {
  return Relude_IO.flatMap((function (param) {
                return Curry._1(setView, {
                            TAG: /* PostAShift */4,
                            _0: undefined
                          });
              }), resetPostAShift);
}

function container(isActiveTab) {
  var arg = function (param) {
    return BrowserStyle.withFont(param, /* Quicksand */0, /* Medium */3, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
                  hd: BrowserStyle.color(isActiveTab ? ({
                            TAG: /* Teal */6,
                            _0: /* Medium */2
                          }) : ({
                            TAG: /* White */7,
                            _0: /* Light */2
                          })),
                  tl: {
                    hd: BrowserStyle.padding2(BrowserStyle.Spacing.medium, BrowserStyle.Spacing.xSmall),
                    tl: {
                      hd: BrowserStyle.position(BrowserStyle.relative),
                      tl: /* [] */0
                    }
                  }
                }));
}

var activeTabLine = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* Teal */6,
            _0: /* Medium */2
          }),
      tl: {
        hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.125)),
        tl: {
          hd: BrowserStyle.bottom(BrowserStyle.zero),
          tl: {
            hd: BrowserStyle.height(BrowserStyle.rem(0.25)),
            tl: {
              hd: BrowserStyle.left(BrowserStyle.zero),
              tl: {
                hd: BrowserStyle.position(BrowserStyle.absolute),
                tl: {
                  hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var unreadIndicator = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf("flexStart"),
      tl: {
        hd: BrowserStyle.backgroundColor({
              TAG: /* Red */5,
              _0: /* Medium */2
            }),
        tl: {
          hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.25)),
          tl: {
            hd: BrowserStyle.height(BrowserStyle.rem(0.5)),
            tl: {
              hd: BrowserStyle.width(BrowserStyle.rem(0.5)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles$1 = {
  container: container,
  activeTabLine: activeTabLine,
  unreadIndicator: unreadIndicator
};

function WebContainers_BusinessDashboard$Presentation$Header$Desktop$Tabs$Tab(Props) {
  var alertCount = Props.alertCount;
  var icon = Props.icon;
  var isActiveTab = Props.isActiveTab;
  var onClick = Props.onClick;
  var title = Props.title;
  return React.createElement(BrowserComponents_Button.Base.make, {
              children: null,
              className: container(isActiveTab),
              onClick: (function (param) {
                  return onClick;
                })
            }, React.createElement(BrowserComponents_FlexRow.make, {
                  children: null
                }, React.createElement(BrowserComponents_Icon.make, {
                      color: isActiveTab ? ({
                            TAG: /* Teal */6,
                            _0: /* Medium */2
                          }) : ({
                            TAG: /* White */7,
                            _0: /* Light */2
                          }),
                      icon: {
                        TAG: /* Small */1,
                        _0: icon
                      }
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(BrowserComponents_Text.make, {
                      children: title
                    }), Curry._2(Relude_Int.OrdNamed.greaterThan, 0, alertCount) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                            size: /* XSmall */2
                          }), React.createElement("div", {
                            className: unreadIndicator
                          })) : null), isActiveTab ? React.createElement("div", {
                    className: activeTabLine
                  }) : null);
}

var Tab = {
  Styles: Styles$1,
  make: WebContainers_BusinessDashboard$Presentation$Header$Desktop$Tabs$Tab
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: /* [] */0
    });

var Styles$2 = {
  container: container$1
};

function tabs(toDoAlertCount) {
  return [
          {
            alertCount: 0,
            icon: {
              TAG: /* Shift */6,
              _0: /* CalendarChecked */2
            },
            title: "Upcoming Shifts",
            view: {
              TAG: /* ShiftsList */1,
              _0: /* Upcoming */1
            }
          },
          {
            alertCount: 0,
            icon: {
              TAG: /* Button */1,
              _0: /* TimeBack */12
            },
            title: "Past Shifts",
            view: {
              TAG: /* ShiftsList */1,
              _0: /* Past */0
            }
          },
          {
            alertCount: toDoAlertCount,
            icon: {
              TAG: /* Shift */6,
              _0: /* Clipboard */8
            },
            title: "To Do",
            view: {
              TAG: /* ToDo */2,
              _0: /* PayTips */{
                _0: undefined
              }
            }
          }
        ];
}

function WebContainers_BusinessDashboard$Presentation$Header$Desktop$Tabs(Props) {
  var currentDashboardView = Props.currentDashboardView;
  var setView = Props.setView;
  var toDoAlertCount = Props.toDoAlertCount;
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: container$1,
              children: React.createElement(BrowserComponents_SpacedElements.make, {
                    children: (function (param) {
                        var view = param.view;
                        return React.createElement(WebContainers_BusinessDashboard$Presentation$Header$Desktop$Tabs$Tab, {
                                    alertCount: param.alertCount,
                                    icon: param.icon,
                                    isActiveTab: WebTypes_View.BusinessDashboard.eq(view, currentDashboardView),
                                    onClick: Curry._1(setView, WebTypes_View.businessDashboard(view)),
                                    title: param.title
                                  });
                      }),
                    elements: tabs(toDoAlertCount),
                    keyExtractor: (function (param, _index) {
                        return param.title;
                      }),
                    spacerSize: /* XLarge */6
                  })
            });
}

var Tabs = {
  Tab: Tab,
  Styles: Styles$2,
  tabs: tabs,
  make: WebContainers_BusinessDashboard$Presentation$Header$Desktop$Tabs
};

var logoContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexBasis(BrowserStyle.pct(20.0)),
      tl: /* [] */0
    });

var trailingButtonsContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.pct(20.0)),
        tl: {
          hd: BrowserStyle.justifyContent(BrowserStyle.flexEnd),
          tl: /* [] */0
        }
      }
    });

var dropdownContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.border(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
            TAG: /* Grey */2,
            _0: /* Medium */2
          }),
      tl: {
        hd: BrowserStyle.backgroundColor({
              TAG: /* White */7,
              _0: /* Light */2
            }),
        tl: {
          hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
          tl: {
            hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
            tl: {
              hd: BrowserStyle.boxShadow(/* Medium */2),
              tl: {
                hd: BrowserStyle.marginTop(BrowserStyle.rem(0.65)),
                tl: {
                  hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.xSmall),
                  tl: {
                    hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.xSmall),
                    tl: {
                      hd: BrowserStyle.whiteSpace(BrowserStyle.nowrap),
                      tl: {
                        hd: BrowserStyle.width(BrowserStyle.unset),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var dropdownButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.flexStart),
      tl: /* [] */0
    });

function arg(param, param$1) {
  return BrowserStyle.withFont(param, /* Quicksand */0, param$1, /* Bold */2);
}

var dropdownText = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Dark */1
              }),
          tl: {
            hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.small),
            tl: {
              hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.medium),
              tl: {
                hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.large),
                tl: {
                  hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.small),
                  tl: {
                    hd: BrowserStyle.textAlign("left"),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }));

var Styles$3 = {
  logoContainer: logoContainer,
  trailingButtonsContainer: trailingButtonsContainer,
  dropdownContainer: dropdownContainer,
  dropdownButton: dropdownButton,
  dropdownText: dropdownText
};

function WebContainers_BusinessDashboard$Presentation$Header$Desktop(Props) {
  var currentDashboardView = Props.currentDashboardView;
  var invoiceNinjaContactKey = Props.invoiceNinjaContactKey;
  var logout = Props.logout;
  var navigateToPostAShift = Props.navigateToPostAShift;
  var setView = Props.setView;
  var toDoAlertCount = Props.toDoAlertCount;
  return React.createElement(WebComponents_Header.Desktop.make, {
              children: null,
              logoContainerClassName: logoContainer,
              onLogoClick: Curry._1(setView, {
                    TAG: /* BusinessDashboard */0,
                    _0: {
                      TAG: /* ShiftsList */1,
                      _0: /* Upcoming */1
                    }
                  })
            }, React.createElement(WebContainers_BusinessDashboard$Presentation$Header$Desktop$Tabs, {
                  currentDashboardView: currentDashboardView,
                  setView: setView,
                  toDoAlertCount: toDoAlertCount
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  className: trailingButtonsContainer,
                  children: null
                }, React.createElement(BrowserComponents_Button.make, {
                      actionPriority: /* Primary */0,
                      iconLeft: {
                        TAG: /* Shift */6,
                        _0: /* SelectArea */18
                      },
                      onClick: (function (param) {
                          return Curry._1(navigateToPostAShift, undefined);
                        }),
                      size: /* Small */0,
                      testId: "HeaderPostAShiftButton",
                      title: "Post a Shift"
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_Dropdown.Base.make, {
                      buttonContent: (function (param) {
                          return React.createElement(BrowserComponents_Icon.make, {
                                      color: {
                                        TAG: /* White */7,
                                        _0: /* Light */2
                                      },
                                      icon: {
                                        TAG: /* Small */1,
                                        _0: {
                                          TAG: /* Navigation */5,
                                          _0: /* Profile */8
                                        }
                                      },
                                      size: /* Large */3,
                                      testId: "profileButton"
                                    });
                        }),
                      children: React.createElement(BrowserComponents_FlexColumn.make, {
                            children: null
                          }, Relude_Option.fold(null, (function (invoiceNinjaContactKey) {
                                  return React.createElement(ReactUtils.WithTestId.make, {
                                              id: "invoiceButton",
                                              children: React.createElement("a", {
                                                    href: getInvoiceUrlForKey(invoiceNinjaContactKey),
                                                    target: "_blank"
                                                  }, React.createElement(BrowserComponents_Text.make, {
                                                        className: dropdownText,
                                                        children: "Invoice"
                                                      }))
                                            });
                                }), invoiceNinjaContactKey), React.createElement(BrowserComponents_Button.Base.make, {
                                children: React.createElement(BrowserComponents_Text.make, {
                                      className: dropdownText,
                                      children: "Payments"
                                    }),
                                onClick: (function (param) {
                                    return Curry._1(setView, {
                                                TAG: /* BusinessDashboard */0,
                                                _0: /* Payments */0
                                              });
                                  }),
                                testId: "paymentsButton"
                              }), React.createElement("a", {
                                href: getBusinessReferralLink,
                                target: "_blank"
                              }, React.createElement(BrowserComponents_Text.make, {
                                    className: dropdownText,
                                    children: "Referrals"
                                  })), React.createElement(BrowserComponents_Button.Base.make, {
                                children: React.createElement(BrowserComponents_Text.make, {
                                      className: dropdownText,
                                      children: "Settings"
                                    }),
                                onClick: (function (param) {
                                    return Curry._1(setView, {
                                                TAG: /* BusinessDashboard */0,
                                                _0: {
                                                  TAG: /* Settings */0,
                                                  _0: {
                                                    TAG: /* Admins */0,
                                                    _0: /* Viewing */0
                                                  }
                                                }
                                              });
                                  }),
                                testId: "settingsButton"
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* XSmall */2
                              }), React.createElement(BrowserComponents_HR.make, {}), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* XSmall */2
                              }), React.createElement(BrowserComponents_Button.Base.make, {
                                children: React.createElement(BrowserComponents_Text.make, {
                                      className: dropdownText,
                                      children: "Logout"
                                    }),
                                onClick: (function (param) {
                                    return logout;
                                  }),
                                testId: "logoutButton"
                              })),
                      containerClassName: (function (param, param$1) {
                          return dropdownContainer;
                        }),
                      horizontalOrientation: /* Left */0,
                      verticalOrientation: /* Below */1
                    })));
}

var Desktop = {
  Tabs: Tabs,
  Styles: Styles$3,
  make: WebContainers_BusinessDashboard$Presentation$Header$Desktop
};

var wrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 0.0
          }),
      tl: {
        hd: BrowserStyle.position(BrowserStyle.sticky),
        tl: {
          hd: BrowserStyle.top(BrowserStyle.zero),
          tl: {
            hd: BrowserStyle.zIndex(50),
            tl: /* [] */0
          }
        }
      }
    });

var dropdownButton$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.backgroundColor({
              TAG: /* White */7,
              _0: /* Light */2
            }),
        tl: {
          hd: BrowserStyle.borderBottom(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
                TAG: /* Grey */2,
                _0: /* Lightest */4
              }),
          tl: {
            hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
            tl: /* [] */0
          }
        }
      }
    });

function arg$1(param, param$1, param$2) {
  return BrowserStyle.withFont(param, param$1, param$2, /* Semibold */1);
}

var dropdownButtonTitle = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined, undefined), {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: /* [] */0
        }));

var dropdownContainer$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderRadius(BrowserStyle.zero),
      tl: /* [] */0
    });

function dropdownOverlay(isShowing) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.display(isShowing ? "block" : "none"),
              tl: {
                hd: BrowserStyle.position("fixed"),
                tl: {
                  hd: BrowserStyle.top(BrowserStyle.px(0)),
                  tl: {
                    hd: BrowserStyle.left(BrowserStyle.px(0)),
                    tl: {
                      hd: BrowserStyle.right(BrowserStyle.px(0)),
                      tl: {
                        hd: BrowserStyle.bottom(BrowserStyle.px(0)),
                        tl: {
                          hd: BrowserStyle.zIndex(5),
                          tl: {
                            hd: Css.backgroundColor(BrowserStyle.rgba(0, 0, 0, 0.2)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

var drawerQwickLogoButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

var drawerHeader = Curry._1(BrowserStyle.merge, {
      hd: BrowserStyle.texturedDarkBackground,
      tl: {
        hd: Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.justifyContent(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.flex({
                      NAME: "num",
                      VAL: 1.0
                    }),
                tl: {
                  hd: BrowserStyle.flexBasis(BrowserStyle.pct(40.0)),
                  tl: {
                    hd: BrowserStyle.padding(BrowserStyle.Spacing.large),
                    tl: /* [] */0
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var drawerLinksContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexBasis(BrowserStyle.pct(60.0)),
          tl: {
            hd: BrowserStyle.padding(BrowserStyle.Spacing.large),
            tl: /* [] */0
          }
        }
      }
    });

function arg$2(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XXLarge */6, /* Bold */2);
}

var drawerLink = Curry._1(BrowserStyle.style, Curry._1(arg$2(undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Dark */1
              }),
          tl: {
            hd: BrowserStyle.cursor("pointer"),
            tl: {
              hd: BrowserStyle.textAlign("left"),
              tl: /* [] */0
            }
          }
        }));

var Styles$4 = {
  wrapper: wrapper,
  dropdownButton: dropdownButton$1,
  dropdownButtonTitle: dropdownButtonTitle,
  dropdownContainer: dropdownContainer$1,
  dropdownOverlay: dropdownOverlay,
  drawerQwickLogoButton: drawerQwickLogoButton,
  drawerHeader: drawerHeader,
  drawerLinksContainer: drawerLinksContainer,
  drawerLink: drawerLink
};

function WebContainers_BusinessDashboard$Presentation$Header$Mobile(Props) {
  var currentDashboardView = Props.currentDashboardView;
  var invoiceNinjaContactKey = Props.invoiceNinjaContactKey;
  var logout = Props.logout;
  var navigateToPostAShift = Props.navigateToPostAShift;
  var setView = Props.setView;
  var toDoAlertCount = Props.toDoAlertCount;
  var match = ReactIO.useState(function (param) {
        return false;
      });
  var setIsShowing = match[1];
  var isShowing = match[0];
  var getDashboardViewDisplayString = function (param) {
    if (typeof param === "number") {
      return "Payments";
    }
    switch (param.TAG | 0) {
      case /* Settings */0 :
          return "Settings";
      case /* ShiftsList */1 :
          if (param._0) {
            return "Upcoming Shifts";
          } else {
            return "Past Shifts";
          }
      case /* ToDo */2 :
          return "To Do" + (
                  Curry._2(Relude_Int.OrdNamed.greaterThan, 0, toDoAlertCount) ? " (" + (Relude_Int.toString(toDoAlertCount) + ")") : ""
                );
      
    }
  };
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: wrapper,
              children: null
            }, React.createElement(WebComponents_Header.Mobile.make, {
                  onLogoClick: Curry._1(setView, {
                        TAG: /* BusinessDashboard */0,
                        _0: {
                          TAG: /* ShiftsList */1,
                          _0: /* Upcoming */1
                        }
                      }),
                  onMenuClick: Curry._1(setIsShowing, true)
                }), React.createElement(BrowserComponents_Dropdown.Base.make, {
                  buttonContent: (function (param) {
                      return React.createElement(BrowserComponents_FlexRow.make, {
                                  className: dropdownButton$1,
                                  children: null
                                }, React.createElement(BrowserComponents_Text.make, {
                                      className: dropdownButtonTitle,
                                      children: getDashboardViewDisplayString(currentDashboardView)
                                    }), React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* Small */3
                                    }), React.createElement(BrowserComponents_Icon.make, {
                                      icon: {
                                        TAG: /* Small */1,
                                        _0: {
                                          TAG: /* Arrow */0,
                                          _0: /* ChevronBottom */10
                                        }
                                      }
                                    }));
                    }),
                  children: React.createElement(BrowserComponents_FlexColumn.make, {
                        children: Relude_Array.mapWithIndex((function (view, index) {
                                return React.createElement(BrowserComponents_Dropdown.Item.make, {
                                            children: getDashboardViewDisplayString(view),
                                            isSelected: WebTypes_View.BusinessDashboard.eq(view, currentDashboardView),
                                            onSelectItem: Curry._1(setView, WebTypes_View.businessDashboard(view)),
                                            size: /* Medium */2,
                                            key: Relude_Int.toString(index)
                                          });
                              }), [
                              {
                                TAG: /* ShiftsList */1,
                                _0: /* Upcoming */1
                              },
                              {
                                TAG: /* ShiftsList */1,
                                _0: /* Past */0
                              },
                              {
                                TAG: /* ToDo */2,
                                _0: undefined
                              }
                            ])
                      }),
                  containerClassName: (function (param, param$1) {
                      return dropdownContainer$1;
                    }),
                  horizontalOrientation: /* Left */0,
                  verticalOrientation: /* Below */1
                }), React.createElement(BrowserComponents_MobilePopoutMenu.make, {
                  isShowing: isShowing,
                  children: null
                }, React.createElement(BrowserComponents_FlexColumn.make, {
                      className: drawerHeader,
                      children: null
                    }, React.createElement(BrowserComponents_Button.Base.make, {
                          children: React.createElement(BrowserComponents_Image.make, {
                                image: {
                                  TAG: /* Logo */2,
                                  _0: /* Light */6
                                }
                              }),
                          className: drawerQwickLogoButton,
                          onClick: (function (param) {
                              return Curry._1(setView, {
                                          TAG: /* BusinessDashboard */0,
                                          _0: {
                                            TAG: /* ShiftsList */1,
                                            _0: /* Upcoming */1
                                          }
                                        });
                            })
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Large */5
                        }), React.createElement(BrowserComponents_Button.make, {
                          actionPriority: /* Primary */0,
                          iconLeft: {
                            TAG: /* Shift */6,
                            _0: /* SelectArea */18
                          },
                          onClick: (function (param) {
                              return Curry._1(navigateToPostAShift, undefined);
                            }),
                          title: "Post a Shift"
                        })), React.createElement(BrowserComponents_FlexColumn.make, {
                      className: drawerLinksContainer,
                      children: null
                    }, Relude_Option.fold(null, (function (invoiceNinjaContactKey) {
                            return React.createElement(React.Fragment, undefined, React.createElement("a", {
                                            href: getInvoiceUrlForKey(invoiceNinjaContactKey),
                                            target: "_blank"
                                          }, React.createElement(BrowserComponents_Text.make, {
                                                className: drawerLink,
                                                children: "Invoice"
                                              })), React.createElement(BrowserComponents_Spacer.make, {
                                            size: /* Large */5
                                          }));
                          }), invoiceNinjaContactKey), React.createElement(BrowserComponents_Button.Base.make, {
                          children: React.createElement(BrowserComponents_Text.make, {
                                children: "Payments"
                              }),
                          className: drawerLink,
                          onClick: (function (param) {
                              return Curry._1(setView, {
                                          TAG: /* BusinessDashboard */0,
                                          _0: /* Payments */0
                                        });
                            })
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Large */5
                        }), React.createElement("a", {
                          href: getBusinessReferralLink,
                          target: "_blank"
                        }, React.createElement(BrowserComponents_Text.make, {
                              className: drawerLink,
                              children: "Referrals"
                            })), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Large */5
                        }), React.createElement(BrowserComponents_Button.Base.make, {
                          children: React.createElement(BrowserComponents_Text.make, {
                                children: "Settings"
                              }),
                          className: drawerLink,
                          onClick: (function (param) {
                              return Curry._1(setView, {
                                          TAG: /* BusinessDashboard */0,
                                          _0: {
                                            TAG: /* Settings */0,
                                            _0: {
                                              TAG: /* Admins */0,
                                              _0: /* Viewing */0
                                            }
                                          }
                                        });
                            })
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Large */5
                        }), React.createElement(BrowserComponents_Button.Base.make, {
                          children: React.createElement(BrowserComponents_Text.make, {
                                children: "Logout"
                              }),
                          className: drawerLink,
                          onClick: (function (param) {
                              return logout;
                            })
                        }))), React.createElement("div", {
                  className: dropdownOverlay(isShowing),
                  onClick: (function (param) {
                      return IOUtils.unsafeRunHandledAsync(Curry._1(setIsShowing, false));
                    })
                }));
}

var Mobile = {
  Styles: Styles$4,
  make: WebContainers_BusinessDashboard$Presentation$Header$Mobile
};

function WebContainers_BusinessDashboard$Presentation$Header(Props) {
  var currentDashboardView = Props.currentDashboardView;
  var invoiceNinjaContactKey = Props.invoiceNinjaContactKey;
  var logout = Props.logout;
  var navigateToPostAShift = Props.navigateToPostAShift;
  var responsiveLayout = Props.responsiveLayout;
  var setView = Props.setView;
  var toDoAlertCount = Props.toDoAlertCount;
  if (responsiveLayout >= 2) {
    return React.createElement(WebContainers_BusinessDashboard$Presentation$Header$Desktop, {
                currentDashboardView: currentDashboardView,
                invoiceNinjaContactKey: invoiceNinjaContactKey,
                logout: logout,
                navigateToPostAShift: navigateToPostAShift,
                setView: setView,
                toDoAlertCount: toDoAlertCount
              });
  } else {
    return React.createElement(WebContainers_BusinessDashboard$Presentation$Header$Mobile, {
                currentDashboardView: currentDashboardView,
                invoiceNinjaContactKey: invoiceNinjaContactKey,
                logout: logout,
                navigateToPostAShift: navigateToPostAShift,
                setView: setView,
                toDoAlertCount: toDoAlertCount
              });
  }
}

var Header = {
  getBusinessReferralLink: getBusinessReferralLink,
  getInvoiceUrlForKey: getInvoiceUrlForKey,
  postAShift: postAShift,
  Desktop: Desktop,
  Mobile: Mobile,
  make: WebContainers_BusinessDashboard$Presentation$Header
};

function container$2(param) {
  if (typeof param === "number") {
    return Curry._1(BrowserStyle.style, {
                hd: BrowserStyle.width(BrowserStyle.vw(100.0)),
                tl: /* [] */0
              });
  }
  switch (param.TAG | 0) {
    case /* Settings */0 :
        return Curry._1(BrowserStyle.style, {
                    hd: BrowserStyle.width(BrowserStyle.vw(100.0)),
                    tl: /* [] */0
                  });
    case /* ShiftsList */1 :
    case /* ToDo */2 :
        break;
    
  }
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
              tl: {
                hd: BrowserStyle.position(BrowserStyle.fixed),
                tl: {
                  hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                  tl: /* [] */0
                }
              }
            });
}

var Styles$5 = {
  container: container$2
};

function showToDoTabMarketingCalloutIfNeeded(showModal) {
  if (WebTypes_MarketingCallout.hasUserSeenCalloutAlready(/* ToDoTab */0)) {
    return Relude_IO.pure(undefined);
  } else {
    return Curry._2(IOUtils.IOWithUnitError.mapTuple2, (function (param, param$1) {
                  
                }), [
                Curry._1(showModal, /* ToDoTab */0),
                WebTypes_MarketingCallout.setUserHasSeenCallout(/* ToDoTab */0)
              ]);
  }
}

function WebContainers_BusinessDashboard$Presentation(Props) {
  var authorizedClient = Props.authorizedClient;
  var currentDashboardView = Props.currentDashboardView;
  var fetchPayTipsToDos = Props.fetchPayTipsToDos;
  var logout = Props.logout;
  var navigateToPostAShift = Props.navigateToPostAShift;
  var responsiveLayout = Props.responsiveLayout;
  var setView = Props.setView;
  var showModal = Props.showModal;
  var startSubscriptions = Props.startSubscriptions;
  var stopSubscriptions = Props.stopSubscriptions;
  var toDoAlertCount = Props.toDoAlertCount;
  var user = Props.user;
  var partial_arg = (function (param) {
      return Relude_Globals.$$const(stopSubscriptions, param);
    });
  var arg = function (param, param$1) {
    return ReactIO.useIOOnMount(partial_arg, param, param$1);
  };
  Curry._2(arg, undefined, startSubscriptions);
  ReactIO.useHandledIOOnMount(undefined)(fetchPayTipsToDos);
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          if (typeof param === "number" || param.TAG !== /* ToDo */2) {
            return Relude_IO.pure(undefined);
          } else {
            return showToDoTabMarketingCalloutIfNeeded(showModal);
          }
        }), currentDashboardView);
  ReactIO.useEffect1(undefined, undefined, (function (alertCount) {
          if (Curry._2(Relude_Int.OrdNamed.greaterThan, 0, alertCount)) {
            return showToDoTabMarketingCalloutIfNeeded(showModal);
          } else {
            return Relude_IO.pure(undefined);
          }
        }), toDoAlertCount);
  var tmp;
  if (typeof currentDashboardView === "number") {
    tmp = React.createElement(WebContainers_BusinessDashboard_Payments.make, {
          authorizedClient: authorizedClient,
          setView: setView,
          user: user
        });
  } else {
    switch (currentDashboardView.TAG | 0) {
      case /* Settings */0 :
          tmp = React.createElement(WebContainers_BusinessDashboard_Settings.make, {
                currentSettingsView: currentDashboardView._0,
                user: user
              });
          break;
      case /* ShiftsList */1 :
          tmp = React.createElement(WebContainers_BusinessDashboard_Shifts.make, {
                currentShiftsListView: currentDashboardView._0,
                user: user
              });
          break;
      case /* ToDo */2 :
          tmp = React.createElement(WebContainers_BusinessDashboard_ToDo.make, {
                currentToDoView: currentDashboardView._0,
                responsiveLayout: responsiveLayout
              });
          break;
      
    }
  }
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container$2(currentDashboardView),
              children: null
            }, React.createElement(WebContainers_BusinessDashboard$Presentation$Header, {
                  currentDashboardView: currentDashboardView,
                  invoiceNinjaContactKey: user.business.invoiceNinjaContactKey,
                  logout: logout,
                  navigateToPostAShift: navigateToPostAShift,
                  responsiveLayout: responsiveLayout,
                  setView: setView,
                  toDoAlertCount: toDoAlertCount
                }), tmp, React.createElement(ReactHotToast.Toaster, BrowserBindings_ReactHotToast.makeProps(undefined, undefined)(undefined, undefined)));
}

var Presentation = {
  Header: Header,
  Styles: Styles$5,
  showToDoTabMarketingCalloutIfNeeded: showToDoTabMarketingCalloutIfNeeded,
  make: WebContainers_BusinessDashboard$Presentation
};

var mapStateToProps = Reselect.createSelector2(undefined, (function (param) {
        return param.layout;
      }), WebStore_Selectors.getToDoAlertCount, (function (responsiveLayout, toDoAlertCount) {
        return {
                responsiveLayout: responsiveLayout,
                toDoAlertCount: toDoAlertCount
              };
      }));

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg_fetchPayTipsToDos = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.fetchPayTipsToDos)));
  var partial_arg_logout = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.logout));
  var partial_arg_navigateToPostAShift = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.navigateToPostAShift, dispatch, param);
                }), partial_arg, param);
  };
  var partial_arg_setView = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                }), partial_arg$1, param);
  };
  var partial_arg_startSubscriptions = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.startSubscriptions)));
  var partial_arg_stopSubscriptions = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.stopSubscriptions)));
  var partial_arg$2 = {
    fetchPayTipsToDos: partial_arg_fetchPayTipsToDos,
    logout: partial_arg_logout,
    navigateToPostAShift: partial_arg_navigateToPostAShift,
    setView: partial_arg_setView,
    startSubscriptions: partial_arg_startSubscriptions,
    stopSubscriptions: partial_arg_stopSubscriptions
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$2, param);
  };
}

function WebContainers_BusinessDashboard(Props) {
  var authorizedClient = Props.authorizedClient;
  var currentDashboardView = Props.currentDashboardView;
  var user = Props.user;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  var stopSubscriptions = param$1.stopSubscriptions;
                  var startSubscriptions = param$1.startSubscriptions;
                  var setView = param$1.setView;
                  var navigateToPostAShift = param$1.navigateToPostAShift;
                  var logout = param$1.logout;
                  var fetchPayTipsToDos = param$1.fetchPayTipsToDos;
                  var toDoAlertCount = param.toDoAlertCount;
                  var responsiveLayout = param.responsiveLayout;
                  return React.createElement(BrowserComponents_WithModal.make, {
                              children: (function (param, showModal) {
                                  return React.createElement(WebContainers_BusinessDashboard$Presentation, {
                                              authorizedClient: authorizedClient,
                                              currentDashboardView: currentDashboardView,
                                              fetchPayTipsToDos: fetchPayTipsToDos,
                                              logout: logout,
                                              navigateToPostAShift: navigateToPostAShift,
                                              responsiveLayout: responsiveLayout,
                                              setView: setView,
                                              showModal: showModal,
                                              startSubscriptions: startSubscriptions,
                                              stopSubscriptions: stopSubscriptions,
                                              toDoAlertCount: toDoAlertCount,
                                              user: user
                                            });
                                }),
                              getModalContent: getContent
                            });
                })
            });
}

var make = WebContainers_BusinessDashboard;

exports.Modals = Modals;
exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* youtubeEmbed Not a pure module */
